import React, {useEffect} from 'react';
import {useVideoPlayer} from "../hooks/useVideoPlayer";

interface VideoSectionProps {
    videoSrc: string;
    posterImage: string;
    children?: React.ReactElement<{ onPlay?: () => void }>;
    onPlayStateChange?: (isPlaying: boolean) => void;
    requestFullscreenOnMobile?: boolean;
}

const VideoSection: React.FC<VideoSectionProps> = ({
                                                       videoSrc,
                                                       posterImage,
                                                       children,
                                                       onPlayStateChange,
                                                       requestFullscreenOnMobile = false
                                                   }) => {
    const {videoRef, error, handlePlay} = useVideoPlayer(requestFullscreenOnMobile);
    const [isActuallyPlaying, setIsActuallyPlaying] = React.useState(false);

    useEffect(() => {
        onPlayStateChange?.(isActuallyPlaying);
    }, [isActuallyPlaying, onPlayStateChange]);

    return (
        <section className="h-screen relative overflow-hidden">

            <video
                ref={videoRef}
                src={videoSrc}
                className={`absolute top-0 left-0 w-full h-full object-cover ${isActuallyPlaying ? 'block' : 'hidden'}`}
                controls
                playsInline
                onPlay={() => setIsActuallyPlaying(true)}
                onPause={() => setIsActuallyPlaying(false)}
                onEnded={() => setIsActuallyPlaying(false)}
            />
            {(!isActuallyPlaying && posterImage === "/images/Video2Thumbnail.JPG") && (
                <div className="absolute w-full md:h-full h-[80%] bg-gradient-to-b md:bg-gradient-to-br from-black z-30">
                    <img className="glamping-wedding" src={'images/JoinUs.png'} alt={'Join Us'}/>
                </div>
            )}
            {/* Show placeholder only when video is not actually playing */}
            {!isActuallyPlaying && (
                <div className="flex items-center justify-center h-screen relative">
                    <img
                        src={posterImage}
                        alt="Video placeholder"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/30"></div>
                    {/* We clone the child, passing the handlePlay function from our hook. */}
                    {children && React.cloneElement(children, {onPlay: handlePlay})}
                    {error && (
                        <div className="absolute bottom-10 z-20 bg-red-800/80 text-white p-4 rounded-md">
                            {error}
                        </div>
                    )}
                </div>
            )}
        </section>
    );
};

export default VideoSection;
